import React from 'react';
import PropTypes from 'prop-types';
import RichTextEditorBase from './RichTextEditorBase';

class RichTextEditor extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override RichTextEditorBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <RichTextEditor> */
    className: PropTypes.string,
    /** Passed in default data for uncontrolled component RichTextEditor */
    defaultValue: PropTypes.string,
    /** If `true`, the input will auto focus */
    autoFocus: PropTypes.bool,
    /** If `true`, the input will not have an underline. */
    onTextChange: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
    data: '',
    autoFocus: false,
  };

  getStyles = type => {
    switch (type) {
      case 'primary':
        return {
          '@global': {
            '.primary .rdw-editor-wrapper': {
              border: '1px solid #C4C4CD',
              minHeight: '200px',
            },
            '.primary .rdw-editor-toolbar': {
              backgroundColor: '#F6F5FA',
              border: 'none',
            },
            '.primary .rdw-editor-main': {
              height: 'auto',
              overflow: 'initial',
            },
            '.primary .rdw-option-wrapper, .primary .rdw-dropdown-wrapper': {
              backgroundColor: 'inherit',
            },
          },
          editWrapper: {
            padding: '0px 0px 16px 0px',
          },
        };
      case 'messaging':
        return {
          mainWrapper: {
            height: '100%',
          },
          editWrapper: {
            padding: '0px',
          },
          '@global': {
            '.rdw-editor-main': {
              height: 'auto',
              overflow: 'initial',
              cursor: 'text',
            },
          },
        };
      default:
        return {};
    }
  };

  getSettings = type => {
    switch (type) {
      case 'primary':
        return {
          toolbar: {
            options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link'],
            inline: {
              inDropdown: false,
              options: ['bold', 'italic', 'underline', 'strikethrough'],
            },
            link: {
              inDropDown: false,
              options: ['link'],
            },
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType } = this.props;
    const styles = this.getStyles(styleType);
    const settings = this.getSettings(styleType);

    return <RichTextEditorBase styles={styles} {...settings} {...this.props} />;
  }
}

export default RichTextEditor;
